'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChainId } from '@morpho-org/blue-sdk';
import { capitalize } from 'lodash-es';
import { memo, useCallback } from 'react';
import type { AssetItem } from '@/components/common/TableAdvancedFilters/AssetFilter';
import AssetFilter from '@/components/common/TableAdvancedFilters/AssetFilter';
import { trackFilterChanged } from '@/lib/analytics/client/trackers/filter';
interface AdvancedAssetFilterProps {
  label: string;
  trackingLabel?: string;
  assets: AssetItem[];
  assetIdsFilter: string[];
  chainIdsFilter?: ChainId[];
  handleAssetIdsFilterChange: (assetIdsFilter: string[]) => void;
  disabled: boolean;
  hasHighestZIndex?: boolean;
  onClear?: () => void;
  showPTFilter?: boolean;
  page?: string;
}
const AdvancedAssetFilter = t0 => {
  const $ = _c(17);
  const {
    label,
    trackingLabel: t1,
    assets,
    assetIdsFilter,
    chainIdsFilter,
    disabled,
    hasHighestZIndex,
    handleAssetIdsFilterChange,
    onClear,
    showPTFilter: t2,
    page
  } = t0;
  const trackingLabel = t1 === undefined ? label : t1;
  const showPTFilter = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== handleAssetIdsFilterChange || $[1] !== page || $[2] !== trackingLabel) {
    t3 = newAssetIdsFilter => {
      handleAssetIdsFilterChange(newAssetIdsFilter);
      if (page) {
        trackFilterChanged({
          filterName: `${trackingLabel}_asset`,
          filterValue: newAssetIdsFilter,
          page
        });
      }
    };
    $[0] = handleAssetIdsFilterChange;
    $[1] = page;
    $[2] = trackingLabel;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const onAssetsChange = t3;
  let t4;
  if ($[4] !== label) {
    t4 = capitalize(label);
    $[4] = label;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== assetIdsFilter || $[7] !== assets || $[8] !== chainIdsFilter || $[9] !== disabled || $[10] !== hasHighestZIndex || $[11] !== label || $[12] !== onAssetsChange || $[13] !== onClear || $[14] !== showPTFilter || $[15] !== t4) {
    t5 = <AssetFilter label={label} allLabel={t4} allAssets={assets} assets={assetIdsFilter} chainIds={chainIdsFilter} onAssetsChange={onAssetsChange} disabled={disabled} hasHighestZIndex={hasHighestZIndex} onClear={onClear} showPTFilter={showPTFilter} />;
    $[6] = assetIdsFilter;
    $[7] = assets;
    $[8] = chainIdsFilter;
    $[9] = disabled;
    $[10] = hasHighestZIndex;
    $[11] = label;
    $[12] = onAssetsChange;
    $[13] = onClear;
    $[14] = showPTFilter;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};
export default memo(AdvancedAssetFilter);